"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const components_1 = require("apps/shared/components");
const SimpleSocialAvatar = ({ socialAccount, publicationType, children }) => (React.createElement("div", { className: 'vf-font-bold flex', style: { fontSize: '1.8rem' } },
    React.createElement(components_1.SocialBadgeSM, { socialNetwork: socialAccount.type, publicationType: publicationType }),
    React.createElement("span", { style: { marginBottom: '-1px', maxWidth: '60%' }, className: 'padding-left-Hx ellipsis' }, socialAccount.username),
    React.createElement("span", { style: { marginLeft: 'auto', flexShrink: 0 } }, children)));
exports.default = SimpleSocialAvatar;
